"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _lodash = require("lodash");
var _LightContainer = _interopRequireDefault(require("../../Atoms/LightContainer"));
var _Anchor = _interopRequireDefault(require("../../Atoms/Anchor"));
var _Image = _interopRequireDefault(require("../../Atoms/Image"));
var _SKUTilesNotification = _interopRequireDefault(require("./SKUTilesNotification"));
var _SKUTilesBuyInfo = _interopRequireDefault(require("./SKUTilesBuyInfo"));
var _SKUTiles = require("./SKUTiles.utils");
require("./SKUTiles.scss");
var SKUTiles = function SKUTiles(_ref) {
  var productItem = _ref.productItem,
    labels = _ref.labels,
    config = _ref.config,
    updateCartQuantity = _ref.updateCartQuantity,
    removeCartItem = _ref.removeCartItem,
    isUserLoggedIn = _ref.isUserLoggedIn,
    disabled = _ref.disabled,
    isObsoleteDiscontinued = _ref.isObsoleteDiscontinued,
    isObsoleteDiscontinuedWithReplacement = _ref.isObsoleteDiscontinuedWithReplacement,
    isSKUUnbuyable = _ref.isSKUUnbuyable,
    isUnavailableItem = _ref.isUnavailableItem,
    includeTaxWithPrice = _ref.includeTaxWithPrice;
  var product = productItem.product,
    entryNumber = productItem.entryNumber,
    _productItem$isFreeGi = productItem.isFreeGift,
    isFreeGift = _productItem$isFreeGi === void 0 ? false : _productItem$isFreeGi,
    _productItem$isFreePr = productItem.isFreeProduct,
    isFreeProduct = _productItem$isFreePr === void 0 ? false : _productItem$isFreePr;
  var imageUrl = product.imageUrl,
    code = product.code,
    sKUPageUrl = product.sKUPageUrl,
    name = product.name,
    _product$purchasable = product.purchasable,
    purchasable = _product$purchasable === void 0 ? false : _product$purchasable,
    _product$addToCartDis = product.addToCartDisabled,
    addToCartDisabled = _product$addToCartDis === void 0 ? false : _product$addToCartDis;
  var productImageUrl = imageUrl || config.productDefaultImageUrl;
  var basePriceData = (0, _SKUTiles.getBasePriceValue)(productItem, includeTaxWithPrice);
  var customerPriceValue = (0, _SKUTiles.getCustomerPriceValue)(productItem, includeTaxWithPrice);
  var basePriceValue = (basePriceData == null ? void 0 : basePriceData.formattedValue) || '';
  var nameLinkURL = sKUPageUrl;
  var SKUImageURL = basePriceValue && productImageUrl || config.productDefaultImageUrl;
  var isFreeItem = isFreeGift || isFreeProduct;
  var isUnavailableProduct = (!purchasable || isObsoleteDiscontinued || isObsoleteDiscontinuedWithReplacement || isSKUUnbuyable || isUnavailableItem || addToCartDisabled) && !isFreeItem;
  return _react.default.createElement(_LightContainer.default, {
    className: "skutile-light-container"
  }, _react.default.createElement("div", {
    className: "row"
  }, _react.default.createElement("div", {
    className: "col-sm-9 col-xs-12"
  }, _react.default.createElement("div", {
    className: "row"
  }, _react.default.createElement("span", {
    className: "col-xs-12 skutile-sku-list-code",
    "data-locator": "sku-number"
  }, labels.sku + ": " + code), _react.default.createElement("div", {
    className: "col-xs-12 skutile-row",
    "data-locator": "sku-name"
  }, !(0, _lodash.isEmpty)(nameLinkURL) ? _react.default.createElement(_Anchor.default, {
    className: "skutile-title",
    to: nameLinkURL,
    elementLocator: "link-sku-name"
  }, name) : _react.default.createElement("label", {
    className: "skutile-title",
    elementLocator: "link-sku-name"
  }, name)), typeof customerPriceValue.formattedValue !== 'undefined' && customerPriceValue.formattedValue !== basePriceValue && !isUnavailableProduct && _react.default.createElement("span", {
    className: "col-xs-12 list-price"
  }, labels.listPrice + " " + basePriceValue))), _react.default.createElement("div", {
    className: "col-sm-3 col-xs-12 skutile-image-container",
    "data-locator": "skutile-image-container"
  }, _react.default.createElement(_Image.default, {
    className: "skutile-image",
    src: SKUImageURL,
    alt: name,
    elementLocator: "image-sku-product"
  }))), _react.default.createElement("div", {
    className: "row"
  }, _react.default.createElement(_SKUTilesBuyInfo.default, {
    productItem: productItem,
    labels: labels,
    config: config,
    updateCartQuantity: updateCartQuantity,
    isUserLoggedIn: isUserLoggedIn,
    basePriceValue: basePriceValue,
    disabled: disabled,
    isObsoleteDiscontinued: isObsoleteDiscontinued,
    isObsoleteDiscontinuedWithReplacement: isObsoleteDiscontinuedWithReplacement,
    isUnavailableProduct: isUnavailableProduct,
    isSKUUnbuyable: isSKUUnbuyable,
    isUnavailableItem: isUnavailableItem,
    includeTaxWithPrice: includeTaxWithPrice
  }), !isFreeItem && _react.default.createElement("div", {
    className: "col-xs-12 col-md-2 skutile-remove-item-link",
    "data-locator": "skutile-remove-item-link-container"
  }, _react.default.createElement(_Anchor.default, (0, _extends2.default)({
    to: "/#",
    className: "small",
    elementLocator: "link-remove-sku-line-item"
  }, {
    onClick: function onClick(e) {
      e.preventDefault();
      if (!disabled) {
        removeCartItem({
          productName: name,
          entry: entryNumber,
          sKUPageUrl: sKUPageUrl
        });
      }
    }
  }), labels.removeItem))), !isUnavailableProduct && _react.default.createElement(_SKUTilesNotification.default, {
    productItem: productItem,
    product: product,
    labels: labels,
    config: config
  }));
};
SKUTiles.defaultProps = {
  productItem: {},
  labels: {},
  config: {},
  updateCartQuantity: function updateCartQuantity() {
    /* default updateCartQuantity handler */
  },
  removeCartItem: function removeCartItem() {
    /* default removeCartItem handler */
  },
  isUserLoggedIn: false,
  disabled: false,
  isObsoleteDiscontinued: false,
  isObsoleteDiscontinuedWithReplacement: false,
  isSKUUnbuyable: false,
  isUnavailableItem: false,
  includeTaxWithPrice: false
};
var _default = SKUTiles;
exports.default = _default;
module.exports = exports["default"];